<template>
  <v-sheet class="foreground" height="100%">

    <v-layout align-center class="pa-2 c-flex-00a crx-toolbar subheading">

      <v-text-field
      v-model="filters.search.name"
      autocomplete="off"
      placeholder="Search..."
      hide-details
      class="crx-box-input"
      clearable
      ref="searchField"
      color="text"
      solo
      @keydown.down.prevent="focusNextTableRow()"
      @keydown.up.prevent="focusPreviousTableRow()"
      @keydown.enter.prevent="onEnterKeyTableRow()">
      </v-text-field>

    </v-layout>

    <div class="border-b--medium">
      <c-expansion-panel>
        <template v-slot:header="{ expand }">
          <div>
            <v-row align-center class="pa-3 unselectable">
              <v-icon color="textSecondary">mdi-tune</v-icon>
              &nbsp;
              <div class="font-weight-medium textSecondary--text">
                FILTER
              </div>
            </v-row>
          </div>
        </template>
        <template v-slot:body>
          <div class="pa-3">
            <div>
              ITEM FLAGS
            </div>
            <v-checkbox v-model="filters.item_flags.product" label="Finished product" hide-details></v-checkbox>
            <v-checkbox v-model="filters.item_flags.raw_material" label="Raw material" hide-details></v-checkbox>
            <v-checkbox v-model="filters.item_flags.disposable" label="Disposable" hide-details></v-checkbox>
          </div>
        </template>
      </c-expansion-panel>
    </div>

    <!-- MAIN -->
    <div>

      <div 
      v-if="items.length === 0"
      key="a"
      class="pa-4">
        No results found

        <v-card>
          <v-img src="https://cdn.pixabay.com/photo/2017/04/08/22/26/meditation-2214532_1280.jpg">

          </v-img>
        </v-card>
      </div>

      <div v-else>

        <table class="final-table th-no-padding lines-b pointer hover full-width">
          <colgroup ref="colgroup1">
            <col width="30px">
            <col width="15px">
            <col width="10px">
          </colgroup>

          <tr class="unselectable">
            <c-table-header
            title="Name"
            code="name"
            class="sticky"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>
          
            <c-table-header
            title="Stock"
            code="stock"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <c-table-header
            title="Batches"
            code="inventory_instance_count"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>
          </tr>

          <row
          v-for="(item, i) in items" 
          :key="item.id"
          :item="item"
          :searchFilters="filters.search"
          :active="currentIndex === i"
          :currentSelection="item.id === currentSelectedID"
          @click.native="clickRow(item)"
          ></row>

        </table>

        <!-- PAGINATION -->
        <c-pagination
        :page="page"
        :pagination="pagination"
        :filters="filters"
        compact
        @updatePageNumber="updatePageNumber"
        @goToFirstPage="goToFirstPage"
        @goToPreviousPage="goToPreviousPage"
        @goToNextPage="goToNextPage"
        @goToLastPage="goToLastPage"
        ></c-pagination>
        <!-- PAGINATION -->

      </div>

    </div>

  </v-sheet>
</template>

<script>
import Row from './row'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListRouteBindings'
import ServerListKeyboardBindings from '@/mixins/ServerListKeyboardBindings'

export default {
  components: {
    Row
  },
  mixins: [ServerListController, ServerListBindings, ServerListKeyboardBindings],
  props: ['url', 'urlArgs'],
  data () {
    return {
      filters: {
        rowsPerPage: 10,
        sortCol: 'name',
        sortAscending: true,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          sku: '',
          id: '',
          name: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        item_flags: {
          product: false,
          raw_material: false,
          disposable: false
        },
        categories: []
      },
      page: 0
    }
  },
  computed: {
  },
  methods: {
    init (query) {
      this.filters.search.name = query
    },
    onEnterKeyTableRow () {
      var match = this.items[this.currentIndex]
      if (match) {
        this.clickRow(match)
      }
    },
    clickRow (item) {
      this.currentIndex = this.items.indexOf(item)
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        // this.$router.push('/inventory/inventory-definition/view/' + item.id)
        this.$emit('onItemSelected', item)
      }
    },
    onOpenDrawer () {
      this.$nextTick(() => {
        try {
          this.currentIndex = 0
          // this.filters.search.name = ''
          this.$refs.searchField.focus()
        } catch (error) {
          console.log(error)
        }
        this.loadAPI()
      })
      /* else {
        try {
          this.$refs.searchField.blur()
        } catch (error) {
          console.log(error)
        }
      } */
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        this.$axios.get(`/inventory/grouped?filters=${encodedFilters}&page=${this.page}`)
          .then(response => {
            var hrend = response.data.execution_time
            // console.log(hrend)
            // console.info('Execution time (hr): %ds %dms', hrend[0], hrend[1] / 1000000)
            var rows = response.data.rows
            this.pagination.rowCount = response.data.count
            this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
            if (this.items.length > rows.length) {
              this.currentIndex = 0
            }
            this.items = rows
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
  }
}
</script>